import Modal from 'react-modal';
import { useLocalisationService } from "providers/LocalisationProvider";
import { useModalScrollLock } from 'hooks/useModalScrollLock';

Modal.setAppElement('#root');

export const ErrorModal  = ({content, renderOk, isOpen, onClose}) => {
   
    useModalScrollLock(isOpen);

    const l = useLocalisationService();

    const renderContent = (content )=> {
        if(renderOk){
            return <div className='error-content flexbox centered'>
                {content}
            </div>
        }

        else return content;
    }

    const renderOkButton = () => {

        const errorOkString = l.getString('ERROR_OK');

        if(!renderOk){
            return <div/>;
        }
 
        return <div className="flexbox">                     
            <button className="error-ok-button" onClick={onClose}>
                {errorOkString}
            </button>
        </div>
    }
    
    return (
        <Modal
            className="modal error-modal"
            overlayClassName="modal-overlay error-modal-overlay"
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Error Modal"
        >
            {renderContent(content)}
            {renderOkButton()}
        </Modal>
    );
}